import { Box, Switch, Typography } from '@mui/material';
import { WidgetProps } from '@rjsf/utils';
import { colors } from '@src/styles';

export const SwitchCheckboxWidget = (props: WidgetProps) => {
  const description = typeof props.schema.description === 'string' ? props.schema.description : undefined;

  return (
    <Box
      component="label"
      htmlFor={props.id}
      sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, cursor: 'pointer', width: 'fit-content' }}
    >
      <Switch
        id={props.id}
        size="small"
        checked={Boolean(props.value)}
        disabled={props.disabled || props.readonly}
        onChange={(event) => props.onChange(event.target.checked)}
        sx={{
          marginLeft: '-8px',
          '& .MuiSwitch-switchBase.Mui-checked': { color: colors.primary.yellow },
          '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
            backgroundColor: colors.primary.yellow,
            opacity: 0.45,
          },
          '& .MuiSwitch-track': { backgroundColor: colors.brand.textMuted },
          '& .MuiSwitch-switchBase.Mui-checked.Mui-disabled': { color: colors.primary.yellow },
          '& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track': { opacity: 0.45 },
        }}
      />
      <Box sx={{ paddingTop: '5px' }}>
        <Typography sx={{ fontSize: '13px', color: colors.brand.textStrong, lineHeight: 1.3 }}>
          {props.label}
          {props.required && <span style={{ color: colors.status.rejected, marginLeft: '4px' }}>*</span>}
        </Typography>
        {description && (
          <Typography sx={{ marginTop: '2px', fontSize: '11.5px', color: colors.brand.textMuted, lineHeight: 1.4 }}>
            {description}
          </Typography>
        )}
      </Box>
    </Box>
  );
};
